/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import Moment from "moment/moment";
import PropTypes from "prop-types";
export default class AddNoteModal extends React.Component {
    static get propTypes() {
        return {
            notes: PropTypes.array,
            holds: PropTypes.array,
            activeCollection: PropTypes.object,
            saveNotesWithHolds: PropTypes.func
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            credit : false,
            rights : false,
            cover : false,
            other : false,
            note : '',
            enableSave: false,
        } ;
        this.toggleHold = this.toggleHold.bind(this);
        this.addNote = this.addNote.bind(this);
        this.saveNote = this.saveNote.bind(this);
    }

    componentDidMount() {
        const stateUpdate = {};
        for (const hold of this.props.holds) {
            stateUpdate[hold.toLowerCase()] = true;
        }
        this.setState(stateUpdate);
    }

    toggleHold(event){
        switch (event.toLowerCase()){
            case 'credit' : {this.state.credit? this.setState({ credit : false}) :  this.setState({ credit : true});}
                break;
            case 'rights' :{this.state.rights? this.setState({ rights : false}) :  this.setState({ rights : true});}
                break;
            case 'cover' : {this.state.cover? this.setState({ cover : false}) :  this.setState({ cover : true});}
                break;
            case 'other' : {this.state.other? this.setState({ other : false}) :  this.setState({ other : true});}
        }

    }

    addNote(event){
        this.setState({ note : event.currentTarget.value, enableSave: true});
    }

    saveNote(){
        if(this.state.note.length < 1){
            return alert("Please enter a note");
        }
        const collectionNotes =  {
            body : this.state.note,
            collection:  this.props.notes && this.props.notes.length > 0 ? this.props.notes[0].collection : this.props.activeCollection,
            collectionNoteHolds: [],
        };

        const changeStatus = {
            Credit: this.state.credit !== this.props.holds.includes('Credit'),
            Rights: this.state.rights !== this.props.holds.includes('Rights'),
            Cover: this.state.cover !== this.props.holds.includes('Cover'),
            Other: this.state.other !== this.props.holds.includes('Other')
        };

        Object.entries(changeStatus).forEach(([holdType, hasChanged]) => {
            if (hasChanged) {
                console.log({
                    holdType, hasChanged, state: this.state, selected : this.state[holdType.toLowerCase()]
                });
                collectionNotes.collectionNoteHolds.push(
                    {
                        hold: holdType,
                        selected : this.state[holdType.toLowerCase()],
                        collectionDTO : this.props.notes && this.props.notes.length > 0 ? this.props.notes[0].collection : this.props.activeCollection,
                    }
                );
            }
        });
        this.props.saveNotesWithHolds(collectionNotes);

        this.setState({
            credit : false,
            rights : false,
            cover : false,
            other : false,
            note : '',
            enableSave: false,
        });
        this.props.onRequestClose();
    }

    render() {
        return <div>
            <div className="note-modal-content">
                <h5> <strong>Add a note </strong> </h5>
                <div className="owner-name">
                    <strong>[N/A]</strong>
                </div>
                <div className="note-content">
                    <textarea placeholder="Add a note" onChange={this.addNote}/>
                </div>
                <strong>Select a hold:</strong>
                <div className="new-note-holds">
                    <span className= {this.state.credit? "selected" : "grey-box" }  onClick={() => this.toggleHold('credit')} >CREDIT</span>
                    <span className= {this.state.rights? "selected" : "grey-box" } onClick={() => this.toggleHold('rights') }>RIGHTS</span>
                    <span className= {this.state.cover? "selected" : "grey-box" } onClick={() => this.toggleHold('cover') }>COVER</span>
                    <span className= {this.state.other? "selected" : "grey-box" } onClick={() => this.toggleHold('other') }>OTHER</span>
                </div>
                <div className="modal-notes">
                    {<div className="notes">
                        {(this.props.notes && this.props.notes.length > 0) ?
                            <div >
                                {this.props.notes.map((notes) =>
                                    <div className="note addNotesNotes" >
                                        <span className="left-cell"> <b>{Moment.utc(notes.createdTimestamp).local().format("MM-DD-YYYY HH:mm:ss")  + " "} [{notes.userFirstName}] : </b>  </span> <div className="right-cell">{
                                            notes.collectionNoteHolds && notes.collectionNoteHolds.length > 0 && notes.collectionNoteHolds.map((holds) =>{
                                                return  <span className={(this.state[holds.hold.toLowerCase()]) ? 'tableBox addNotesNotes orangeBox' : 'tableBox addNotesNotes'} onClick={() => this.toggleHold(holds.hold)} >{holds.hold}</span>;
                                            })
                                        } <span id= "note"> {notes.body}  </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            : null}
                    </div>
                    }
                </div>
            </div>
            <div className="modal-footer">
                <button className="pe-btn--btn_large btn-cancel" onClick={()=>this.props.onRequestClose()} >Cancel</button>
                <button className='pe-btn__primary--btn_large btn-action'  onClick={this.saveNote}>Save</button>
            </div>
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/AddNoteModal.js